var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-dialog",
    {
      attrs: { value: _vm.value, persistent: "", width: "500" },
      on: {
        "click:outside": function($event) {
          return _vm.close()
        }
      }
    },
    [
      _c(
        "v-card",
        [
          _c(
            "v-card-title",
            { staticClass: "pl-5 pr-2 pt-4 pb-2" },
            [
              _c(
                "v-icon",
                { staticClass: "mr-2", attrs: { color: "warning" } },
                [_vm._v("mdi-alert")]
              ),
              _c("div", { staticClass: "title h6" }, [
                _vm._v(" TPR Length Warning ")
              ])
            ],
            1
          ),
          _c("v-container", { staticClass: "pa-0", attrs: { fluid: "" } }, [
            _c("div", { staticClass: "px-6 pb-4 d-flex justify-center" }, [
              _vm._v(
                "TPR promotion is less than 3 weeks in length. Please confirm before continuing."
              )
            ]),
            _c(
              "div",
              { staticClass: "d-flex justify-center" },
              [
                _c(
                  "v-btn",
                  {
                    staticClass: "mb-4 mr-4",
                    attrs: { text: "" },
                    on: {
                      click: function($event) {
                        return _vm.close()
                      }
                    }
                  },
                  [_vm._v(" Cancel ")]
                ),
                _c(
                  "v-btn",
                  {
                    staticClass: "mb-4",
                    attrs: { color: "warning" },
                    on: {
                      click: function($event) {
                        return _vm.confirm()
                      }
                    }
                  },
                  [_vm._v(" Confirm ")]
                )
              ],
              1
            )
          ])
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }